<admin-app-header></admin-app-header>
<app-enterprise-admin-bar></app-enterprise-admin-bar>

<div class="invoices-page">
    <div class="container-fluid">
        <!-- Page Header -->
        <div class="page-header">
            <h1>Invoices</h1>
            <div class="page-header__actions">
                <a [routerLink]="['/admin/invoices/create']" class="btn btn-primary">
                    <i class="fa-solid fa-plus"></i> Create Invoice
                </a>
                <button (click)="globalService.exportcsv('all-invoices')" class="btn btn-secondary">
                    <i class="fa-solid fa-file-csv"></i> Export CSV
                </button>
            </div>
        </div>

        <!-- Summary Stats -->
        <div class="stats-grid">
            <div class="stat-card stat-card--orange">
                <div class="stat-card__icon">
                    <i class="fa-solid fa-clock"></i>
                </div>
                <div class="stat-card__content">
                    <span class="stat-card__label">Due</span>
                    <span class="stat-card__value">{{ getDueCount() }}</span>
                </div>
            </div>
            <div class="stat-card stat-card--green">
                <div class="stat-card__icon">
                    <i class="fa-solid fa-circle-check"></i>
                </div>
                <div class="stat-card__content">
                    <span class="stat-card__label">Paid</span>
                    <span class="stat-card__value">{{ getPaidCount() }}</span>
                </div>
            </div>
            <div class="stat-card stat-card--red">
                <div class="stat-card__icon">
                    <i class="fa-solid fa-circle-xmark"></i>
                </div>
                <div class="stat-card__content">
                    <span class="stat-card__label">Cancelled</span>
                    <span class="stat-card__value">{{ getCancelledCount() }}</span>
                </div>
            </div>
            <div class="stat-card stat-card--blue">
                <div class="stat-card__icon">
                    <i class="fa-solid fa-coins"></i>
                </div>
                <div class="stat-card__content">
                    <span class="stat-card__label">Total Due Value</span>
                    <span class="stat-card__value">{{ getTotalDueValue() | formatRands }}</span>
                </div>
            </div>
        </div>

        <!-- Filter Bar -->
        <div class="filter-bar">
            <div class="filter-bar__left">
                <div class="status-toggle">
                    <button *ngFor="let invoiceStatus of invoiceStates" 
                            class="toggle-btn" 
                            [class.active]="status === invoiceStatus" 
                            (click)="setStatus(invoiceStatus)">
                        {{ invoiceStatus | titlecase }}
                    </button>
                </div>
            </div>
            <div class="filter-bar__right">
                <select class="items-select" [(ngModel)]="itemsPerPage" (change)="onItemsPerPageChange()">
                    <option [ngValue]="25">25 per page</option>
                    <option [ngValue]="50">50 per page</option>
                    <option [ngValue]="100">100 per page</option>
                    <option [ngValue]="200">200 per page</option>
                    <option [ngValue]="500">500 per page</option>
                </select>
                <span class="results-count" *ngIf="invoiceCounts[status] != null">
                    {{ invoiceCounts[status] | number }} total for this status
                </span>
                <span class="results-count results-count--loading" *ngIf="invoiceCounts[status] == null">Loading totals…</span>
            </div>
        </div>

        <!-- Empty State -->
        <div class="empty-state" *ngIf="invoices.length === 0">
            <i class="fa-solid fa-file-invoice-dollar"></i>
            <h3>No invoices found</h3>
            <p>There are no invoices with this status.</p>
        </div>

        <!-- Invoices Table -->
        <div class="table-card" *ngIf="invoices.length > 0">
            <table class="invoices-table" id="all-invoices">
                <thead>
                    <tr>
                        <th>Created</th>
                        <th>Type</th>
                        <th>Due Date</th>
                        <th>Status</th>
                        <th>Invoice</th>
                        <th>Portfolio</th>
                        <th>Parking</th>
                        <th>Client</th>
                        <th>Bays</th>
                        <th>Total</th>
                        <th>Reference</th>
                        <th>Subscription</th>
                        <th>Source</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let invoice of invoices" 
                        (contextmenu)="showContextMenu($event, invoice)" 
                        class="invoice-row"
                        [class.selected]="selectedInvoice === invoice">
                        
                        <!-- Created Date -->
                        <td>
                            <span class="date-text">{{ invoice.createdAt | formatDate }}</span>
                        </td>

                        <!-- Payment Type -->
                        <td>
                            <span class="type-badge" [ngClass]="'type-badge--' + invoice.paymentMethodType?.toLowerCase()">
                                {{ EnumNames.getSubscriptionType(invoice.paymentMethodType) }}
                            </span>
                        </td>

                        <!-- Due Date -->
                        <td>
                            <span class="date-text">{{ invoice.dueDate | formatDate }}</span>
                        </td>

                        <!-- Status -->
                        <td>
                            <span class="status-badge" [ngClass]="'status-badge--' + invoice.status?.toLowerCase()">
                                {{ invoice.status | titlecase }}
                            </span>
                            <span *ngIf="invoice.paygateAttempts" class="attempts-badge">
                                {{ invoice.paygateAttempts }}
                            </span>
                        </td>

                        <!-- Invoice Number -->
                        <td>
                            <a class="invoice-link" (click)="viewInvoiceDetail(invoice)">
                                INV-{{ invoice.invoiceNumber }}
                            </a>
                        </td>

                        <!-- Portfolio -->
                        <td>
                            <a *ngIf="invoice.merchantRef" 
                               [routerLink]="['/', AngularRoutes.MERCHANT, invoice.merchantRef.id]" 
                               class="entity-link">
                                {{ invoice.denormMerchantCompanyName | truncate:[25] }}
                            </a>
                            <span *ngIf="!invoice.merchantRef" class="text-muted">—</span>
                        </td>

                        <!-- Parking -->
                        <td>
                            <a *ngIf="invoice.parkingRef" 
                               [routerLink]="['/', AngularRoutes.parking, invoice.parkingRef.id]" 
                               class="entity-link">
                                {{ invoice.denormParkingTitle | truncate:[25] }}
                            </a>
                            <span *ngIf="!invoice.parkingRef" class="text-muted">—</span>
                        </td>

                        <!-- Client -->
                        <td>
                            <a *ngIf="invoice.clientRef" 
                               [routerLink]="['/', AngularRoutes.client, invoice.clientRef.id, 'invoices']" 
                               class="entity-link">
                                {{ invoice.denormClientFirstName }} {{ invoice.denormClientLastName }}
                            </a>
                            <span *ngIf="!invoice.clientRef" class="text-muted">—</span>
                        </td>

                        <!-- Bays -->
                        <td>
                            <span class="count-badge">
                                <i class="fa-solid fa-car"></i> {{ invoice.baysBooked }}
                            </span>
                        </td>

                        <!-- Total -->
                        <td>
                            <span class="amount-text">{{ invoice.amountTotalDue | formatRands }}</span>
                        </td>

                        <!-- Reference -->
                        <td>
                            <span class="reference-text">{{ invoice.reference || '—' }}</span>
                        </td>

                        <!-- Subscription -->
                        <td>
                            <a *ngIf="invoice.subscriptionRef" 
                               [routerLink]="['/admin', 'subscription', invoice.subscriptionRef.id]" 
                               target="_blank"
                               class="subscription-link">
                                {{ invoice.subscriptionRef.id | slice:0:8 }}...
                            </a>
                            <span *ngIf="!invoice.subscriptionRef" class="text-muted">—</span>
                        </td>

                        <!-- Source -->
                        <td>
                            <span class="source-badge" [ngClass]="invoice.subscriptionRef ? 'source-badge--subscription' : 'source-badge--manual'">
                                <i class="fa-solid" [ngClass]="invoice.subscriptionRef ? 'fa-sync' : 'fa-hand'"></i>
                                {{ invoice.subscriptionRef ? 'Subscription' : 'Manual' }}
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- Pagination (Firestore cursor: first / prev / next only) -->
        <div class="pagination-wrapper" *ngIf="invoices.length > 0 || pageIndex > 0">
            <div class="pagination-info">
                <ng-container *ngIf="getTotalForCurrentStatus() != null; else paginationInfoNoTotal">
                    Showing {{ getRangeStart() }}–{{ getRangeEnd() }} of {{ getTotalForCurrentStatus() | number }}
                    · Page {{ pageIndex + 1 }} of {{ getTotalPages() }}
                    · {{ itemsPerPage }} per query
                </ng-container>
                <ng-template #paginationInfoNoTotal>
                    Showing {{ getRangeStart() }}–{{ getRangeEnd() }}
                    · Page {{ pageIndex + 1 }}
                    · {{ itemsPerPage }} per query
                </ng-template>
            </div>
            <div class="pagination">
                <button class="page-btn" (click)="goToFirstPage()" [disabled]="pageIndex === 0" title="First page">
                    <i class="fa-solid fa-angles-left"></i>
                </button>
                <button class="page-btn" (click)="goToPreviousPage()" [disabled]="pageIndex === 0" title="Previous page">
                    <i class="fa-solid fa-chevron-left"></i>
                </button>
                <button class="page-btn" (click)="goToNextPage()" [disabled]="!hasNextPage" title="Next page">
                    <i class="fa-solid fa-chevron-right"></i>
                </button>
            </div>
        </div>
    </div>
</div>

<!-- Invoice Detail Modal -->
<div class="modal-overlay" *ngIf="showInvoiceDetailModal && modalInvoice" (click)="closeInvoiceDetailModal()">
    <div class="modal-card modal-card--invoice" (click)="$event.stopPropagation()">
        <div class="modal-header modal-header--compact">
            <h2><i class="fa-solid fa-file-invoice-dollar"></i> INV-{{ modalInvoice.invoiceNumber }}</h2>
            <button class="modal-close" type="button" (click)="closeInvoiceDetailModal()">
                <i class="fa-solid fa-xmark"></i>
            </button>
        </div>

        <div class="invoice-modal-tabs">
            <button type="button" class="invoice-modal-tab" [class.is-active]="modalInvoiceTab === 'overview'" (click)="modalInvoiceTab = 'overview'">Overview</button>
            <button type="button" class="invoice-modal-tab" [class.is-active]="modalInvoiceTab === 'lineItems'" (click)="modalInvoiceTab = 'lineItems'">Line items</button>
        </div>

        <div class="modal-body modal-body--invoice">
            <!-- Overview tab -->
            <div class="invoice-tab-pane" *ngIf="modalInvoiceTab === 'overview'">
                <div class="overview-split">
                    <div class="overview-left">
                        <!-- Summary strip -->
                        <div class="overview-summary-row">
                            <span class="status-badge" [ngClass]="'status-badge--' + modalInvoice.status?.toLowerCase()">{{ modalInvoice.status | titlecase }}</span>
                            <span class="overview-total">{{ modalInvoice.amountTotalDue | formatRands }}</span>
                            <span class="type-badge" [ngClass]="'type-badge--' + modalInvoice.paymentMethodType?.toLowerCase()">{{ EnumNames.getSubscriptionType(modalInvoice.paymentMethodType) }}</span>
                            <span class="overview-meta-chip"><i class="fa-solid fa-car"></i> {{ modalInvoice.baysBooked }} bay(s)</span>
                        </div>

                        <!-- Dates: one row on desktop -->
                        <div class="overview-dates-row">
                            <div class="date-cell">
                                <span class="date-stack-k">Created</span>
                                <span class="date-stack-v">{{ modalInvoice.createdAt | formatDate }}</span>
                            </div>
                            <div class="date-cell">
                                <span class="date-stack-k">Due</span>
                                <span class="date-stack-v">{{ modalInvoice.dueDate | formatDate }}</span>
                            </div>
                            <div class="date-cell date-cell--paid">
                                <span class="date-stack-k">Paid</span>
                                <span class="date-stack-v">
                                    <ng-container *ngIf="modalInvoice.paymentDate">{{ modalInvoice.paymentDate | formatDate }}</ng-container>
                                    <span *ngIf="!modalInvoice.paymentDate" class="date-stack-v--muted">—</span>
                                    <span *ngIf="modalInvoice.paidOutDate" class="date-stack-sub">
                                        <span class="date-stack-sep">·</span> Out {{ modalInvoice.paidOutDate | formatDate }}
                                    </span>
                                </span>
                            </div>
                        </div>

                        <!-- Parties compact -->
                        <div class="overview-parties">
                            <div class="overview-party-line">
                                <span class="overview-party-k">Client</span>
                                <a *ngIf="modalInvoice.clientRef" [routerLink]="['/', AngularRoutes.client, modalInvoice.clientRef.id, 'invoices']" class="detail-link" (click)="closeInvoiceDetailModal()">
                                    {{ modalInvoice.denormClientFirstName }} {{ modalInvoice.denormClientLastName }} <i class="fa-solid fa-arrow-up-right-from-square"></i>
                                </a>
                                <span *ngIf="!modalInvoice.clientRef" class="text-muted">—</span>
                            </div>
                            <div class="overview-party-line" *ngIf="modalInvoice.denormClientCompanyName">
                                <span class="overview-party-k">Company</span>
                                <span>{{ modalInvoice.denormClientCompanyName }}</span>
                            </div>
                            <div class="overview-party-line">
                                <span class="overview-party-k">Portfolio</span>
                                <a *ngIf="modalInvoice.merchantRef" [routerLink]="['/', AngularRoutes.MERCHANT, modalInvoice.merchantRef.id]" class="detail-link" (click)="closeInvoiceDetailModal()">
                                    {{ modalInvoice.denormMerchantCompanyName }} <i class="fa-solid fa-arrow-up-right-from-square"></i>
                                </a>
                                <span *ngIf="!modalInvoice.merchantRef" class="text-muted">—</span>
                            </div>
                            <div class="overview-party-line">
                                <span class="overview-party-k">Parking</span>
                                <a *ngIf="modalInvoice.parkingRef" [routerLink]="['/', AngularRoutes.parking, modalInvoice.parkingRef.id]" class="detail-link" (click)="closeInvoiceDetailModal()">
                                    {{ modalInvoice.denormParkingTitle }} <i class="fa-solid fa-arrow-up-right-from-square"></i>
                                </a>
                                <span *ngIf="!modalInvoice.parkingRef" class="text-muted">—</span>
                            </div>
                        </div>

                        <!-- Additional compact -->
                        <div class="overview-extras">
                            <span *ngIf="modalInvoice.reference" class="overview-extra"><strong>Ref</strong> {{ modalInvoice.reference }}</span>
                            <span *ngIf="modalInvoice.subscriptionRef" class="overview-extra">
                                <strong>Sub</strong>
                                <a [routerLink]="['/admin', 'subscription', modalInvoice.subscriptionRef.id]" class="detail-link" target="_blank">{{ modalInvoice.subscriptionRef.id | slice:0:10 }}… <i class="fa-solid fa-arrow-up-right-from-square"></i></a>
                            </span>
                            <span *ngIf="modalInvoice.paygateAttempts" class="overview-extra"><strong>PG</strong> {{ modalInvoice.paygateAttempts }}</span>
                            <span class="overview-extra"><strong>Paid out</strong> {{ modalInvoice.paidOut ? 'Yes' : 'No' }}</span>
                            <span *ngIf="modalInvoice.$key" class="overview-extra overview-extra--id"><strong>ID</strong> {{ modalInvoice.$key }}</span>
                        </div>
                    </div>

                    <aside class="overview-history">
                        <h4 class="overview-history__title"><i class="fa-solid fa-clock-rotate-left"></i> Invoice history</h4>
                        <div class="logs-loading" *ngIf="modalChangeLogsLoading"><i class="fa-solid fa-spinner fa-spin"></i> Loading…</div>
                        <div class="logs-error" *ngIf="!modalChangeLogsLoading && modalChangeLogsError">{{ modalChangeLogsError }}</div>
                        <div class="logs-empty" *ngIf="!modalChangeLogsLoading && !modalChangeLogsError && modalChangeLogs.length === 0">No admin changes logged.</div>
                        <ul class="logs-list logs-list--compact" *ngIf="!modalChangeLogsLoading && !modalChangeLogsError && modalChangeLogs.length > 0">
                            <li *ngFor="let log of modalChangeLogs" class="log-item">
                                <span class="log-date">{{ log.createdAt | formatDate }}</span>
                                <span class="log-text">{{ log.comment }}</span>
                            </li>
                        </ul>
                    </aside>
                </div>
            </div>

            <!-- Line items tab -->
            <div class="invoice-tab-pane invoice-tab-pane--line-items" *ngIf="modalInvoiceTab === 'lineItems'">
                <div class="line-items-empty" *ngIf="!modalInvoice.lineItems?.length">
                    <p>No line items on this invoice.</p>
                </div>
                <table class="line-items-table line-items-table--tab" *ngIf="modalInvoice.lineItems?.length">
                    <thead>
                        <tr>
                            <th>Description</th>
                            <th>Qty</th>
                            <th>Unit</th>
                            <th>VAT</th>
                            <th>Amount</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of modalInvoice.lineItems">
                            <td>{{ item.description }}</td>
                            <td class="text-center">{{ item.quantity }}</td>
                            <td class="text-right">{{ item.unitPrice | formatRands }}</td>
                            <td class="text-center">{{ item.vatRateName }}</td>
                            <td class="text-right">{{ item.lineTotal | formatRands }}</td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td colspan="4" class="text-right"><strong>Subtotal (excl. VAT)</strong></td>
                            <td class="text-right">{{ modalInvoice.totalExcludingVAT | formatRands }}</td>
                        </tr>
                        <tr>
                            <td colspan="4" class="text-right"><strong>VAT</strong></td>
                            <td class="text-right">{{ modalInvoice.totalVAT | formatRands }}</td>
                        </tr>
                        <tr class="total-row">
                            <td colspan="4" class="text-right"><strong>Total due</strong></td>
                            <td class="text-right"><strong>{{ modalInvoice.amountTotalDue | formatRands }}</strong></td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>

        <div class="modal-footer modal-footer--compact">
            <a *ngIf="modalInvoice.clientRef" [routerLink]="['/', AngularRoutes.client, modalInvoice.clientRef.id, 'invoices']" class="btn btn-primary" (click)="closeInvoiceDetailModal()">
                <i class="fa-solid fa-user"></i> View client record
            </a>
            <a *ngIf="modalInvoice.clientRef" [routerLink]="['/client', modalInvoice.clientRef.id, AngularRoutes.INVOICE, modalInvoice.$key]" class="btn btn-secondary" (click)="closeInvoiceDetailModal()">
                <i class="fa-solid fa-file-invoice"></i> Full invoice page
            </a>
            <button type="button" class="btn btn-secondary" (click)="closeInvoiceDetailModal()">Close</button>
        </div>
    </div>
</div>
